module.exports = __webpack_public_path__ + "static/images/calendar.6e65d8d9d64827c40f646bfbe1b44739.svg";